import { useEffect, useState } from 'react';

interface Props {
  onDone: () => void;
}

export function SplashScreen({ onDone }: Props) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 1700);
    const doneTimer = setTimeout(() => onDone(), 2200);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-5"
      style={{
        backgroundColor: '#F5EDE4',
        opacity: fading ? 0 : 1,
        transition: 'opacity 500ms ease-in-out',
      }}
    >
      <img
        src="/logo-wordmark.png"
        alt="Teamity Logo"
        className="w-36 h-36 object-contain"
      />
      <span
        style={{ fontFamily: 'var(--font-serif)', letterSpacing: '0.04em' }}
        className="text-3xl font-medium text-foreground"
      >
        Teamity
      </span>
    </div>
  );
}
